// tslint:disable-next-line: one-variable-per-declaration
export const AuthRoutes = {
  login: '/auth',
  forgotPassword: 'forgot-password',
  authError: 'auth-error',
  error: 'error',
  failure: 'failure',
  pending: 'pending',
  success: 'success',
  otpVerify: '/otp-verify/',
  linkExpired: 'link-expired',
  resetSuccess: 'reset-successfully',
},
  MasterRoutes = {
    dashboard: '/dashboard',
  };

export const AuthRoutesIn = [
  '/auth',
  'forgot-password',
  'auth-error',
  'error',
  'failure',
  'pending',
  'success',
  '/otp-verify/',
  'link-expired',
  'reset-successfully',
];
